// extracted by mini-css-extract-plugin
module.exports = {"hero":"DefaultHero_hero__OJG7j","heroShort":"DefaultHero_heroShort__qI5pB","heroTitle":"DefaultHero_heroTitle__TQLOG","heroNone":"DefaultHero_heroNone__mF1wJ"};